import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import Certificate from '../components/Certificate/Certificate';
import AILoader from '../components/AILoader';
import { getBackendUrl } from '../utils/auth';

const CertificateView = () => {
  const { certNo } = useParams();
  const [searchParams] = useSearchParams();
  const [certificateData, setCertificateData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // We allow passing data via URL query params for dynamic generation (preview mode)
    // Or fetch from backend if only certNo is provided
    const fetchCertificate = async () => {
      try {
        const previewData = searchParams.get('data');
        if (previewData) {
          setCertificateData(JSON.parse(decodeURIComponent(previewData)));
          setLoading(false);
          return;
        }

        const backendUrl = getBackendUrl();
        const response = await fetch(`${backendUrl}/api/certificates/verify/${certNo}`);
        if (!response.ok) throw new Error('Certificate not found');
        const data = await response.json();
        
        setCertificateData(data.certificate);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCertificate();
  }, [certNo, searchParams]);

  if (loading) return <AILoader />;
  if (error) return <div className="w-full h-screen flex items-center justify-center bg-white"><p className="text-xl font-bold text-red-500">Error: {error}</p></div>;
  if (!certificateData) return null;

  return (
    <div className="w-full min-h-screen bg-white flex items-center justify-center">
      <Certificate 
        studentName={certificateData.studentName}
        courseName={certificateData.courseName}
        startDate={certificateData.startDate}
        endDate={certificateData.endDate}
        certificateId={certificateData.certificateNumber || certNo}
        founderName={certificateData.founderName || "Mukesh Gautam"}
        hrName={certificateData.hrName || "Vandana Lokhman"}
      />
    </div>
  );
};

export default CertificateView;
